import type { YearSummary } from '../../../../entities/summary/index.js';
import { formatMonthName } from '../../../../features/payment-view/index.js';
import {
  formatMoneyMaybeApproximate,
  formatMonthTitle,
  LazyMonthBars,
  spentMinorOf,
  toMonthBars,
} from '../../../../features/summary-view/index.js';
import { List, ListItem } from '../../../../shared/ui/index.js';
import { monthsExceedYear, monthsFooterOf } from '../../lib/months-above-year.js';

const NOTHING_TEXT = '—';

type SpendingMonthsProps = {
  summary: YearSummary;
  onChooseMonth: (month: number) => void;
};

export const SpendingMonths = ({ summary, onChooseMonth }: SpendingMonthsProps) => {
  const { spending, year, month: chosenMonth, baseCurrency: currency } = summary;
  const hasSpending = spending.months.some((month) => spentMinorOf(month) > 0);
  const isYearShown = chosenMonth === null;

  if (!isYearShown && !hasSpending) {
    return null;
  }

  const hasEstimates = spending.months.some((month) => month.estimatedMinor > 0);
  const footer = monthsFooterOf({
    hasEstimates: hasSpending && hasEstimates,
    exceedsYear: isYearShown && monthsExceedYear(spending),
  });

  return (
    <List
      header="По місяцях"
      intro={
        hasSpending ? (
          <LazyMonthBars
            bars={toMonthBars(spending.months, chosenMonth)}
            year={year}
            onChoose={onChooseMonth}
          />
        ) : undefined
      }
      footer={footer}
    >
      {isYearShown
        ? spending.months.map((month) => (
            <ListItem
              key={month.month}
              title={formatMonthTitle(formatMonthName(month.month))}
              value={
                spentMinorOf(month) === 0
                  ? NOTHING_TEXT
                  : formatMoneyMaybeApproximate(
                      spentMinorOf(month),
                      currency,
                      month.estimatedMinor > 0,
                    )
              }
              chevron
              onClick={() => {
                onChooseMonth(month.month);
              }}
            />
          ))
        : undefined}
    </List>
  );
};
